import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import { requestPost, requestGet } from '@/api/api'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: [],
    info: {}
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },
  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        requestPost('/login', userInfo).then(response => {
          const result = response.result
          storage.set(ACCESS_TOKEN, 'Bearer ' + result, 7 * 24 * 60 * 60 * 1000)
          commit('SET_TOKEN', 'Bearer ' + result)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        requestGet('/admins/user').then(response => {
          const result = response.result
          const role = result.role
          const newRole = role.map(item => {
            return item.menu
          })
          const permissions = flatArray(newRole)
          result.permissions = permissions

          if (permissions.length > 0) {
            commit('SET_ROLES', permissions)
            commit('SET_INFO', result)
            commit('SET_NAME', { name: result.username, welcome: welcome() })
            commit('SET_AVATAR', result.avatar)
          } else {
            reject(new Error('getInfo: roles must be a non-null array !'))
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        requestPost('/admins/users/logout', state.token).then((response) => {
          resolve()
        }).catch(() => {
          resolve()
        }).finally(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          storage.remove(ACCESS_TOKEN)
        })
      })
    },

    RefreshToken ({ commit }, token) {
      console.log(token)
      storage.set(ACCESS_TOKEN, token, 7 * 24 * 60 * 60 * 1000)
      commit('SET_TOKEN', token)
    }

  }
}

export function flatArray (arr) {
  const newArr = [].concat(...arr.map(x => Array.isArray(x) ? flatArray(x) : x))
  return [...new Set(newArr)]
}

export default user
